<ng-template #guide>
  <div data-cy="theme-extension-banner" class="flex flex-col text-xs leading-snug text-brand-600 xl:text-sm">
    <span
      [innerHtml]="
        'banner.we-ve-detected-you-are-integrating-with-shopify-enable-app-embed-or-add-an-app-block'
          | translate: { guide: guideUrl }
      "
    >
    </span>

    <div class="mt-4 flex flex-wrap items-center gap-3">
      <button mat-flat-button data-cy="banner-enable-embed" (click)="onEnableEmbed()">
        {{ 'banner.enable-app-embed' | translate }}
      </button>
      <button mat-stroked-button data-cy="banner-add-block" (click)="onAddBlock()">
        {{ 'banner.add-app-block' | translate }}
      </button>
    </div>
  </div>
</ng-template>
